import { render, staticRenderFns } from "./LocalConfig.vue?vue&type=template&id=7c56c298"
import script from "./LocalConfig.vue?vue&type=script&lang=js"
export * from "./LocalConfig.vue?vue&type=script&lang=js"
import style0 from "./LocalConfig.vue?vue&type=style&index=0&id=7c56c298&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports